class MuracaatDetayliAramaRequest {
    adi?: string;
    soyadi?: string;
    kimlikNo?: string;
    babaAdi?: string;
    baslangicTarih?: string;
    bitisTarih?: string;
    servisIdStr?: string;
    doktorIdStr?: string;
    kurumIdStr?: string;
    // treekey?: string;
    bagliOrgId?: number;
    pasaportNo?: string;
    aileAdi?: string;
    kurumProtokolNo?: string = "";
    kurumBarkodNo?: string = "";
    lisOrnekNo?: number = null;
}
export default MuracaatDetayliAramaRequest;